import { Component, ElementRef, Inject, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ReportLostComponent } from '../report/lost/lost.component';
import { ReportFoundComponent } from '../report/found/found.component';
import { PetsService } from '../../_services';
import { ThrowStmt } from '@angular/compiler';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

export interface DialogData {
  name: string;
  LostFoundID: any;
  ChipId: any;
}

@Component({
  selector: 'app-dialog',
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.scss']
})
export class DialogComponent {

  ReportForm: FormGroup;
  IsCompany:boolean;
  petDetail: any;
  emailAddress: string = '';
  phoneNumber: string = '';
  @ViewChild('scrollMe') private myScrollContainer: ElementRef;

  constructor(
    public dialogReportLost: MatDialogRef<ReportLostComponent>,
    public dialogReportFound: MatDialogRef<ReportFoundComponent>,
    private formbuilder: FormBuilder,
    private petsService: PetsService,
    private modalService: NgbModal,
    @Inject(MAT_DIALOG_DATA) public data: DialogData
  ) {
    this.petDetail = data;
  }

  submitted = false;
  public calledFrom = "";
  get r() {
    return this.ReportForm.controls;
  }

  ngOnInit(): void {
    debugger;
    this.IsCompany = false;
    this.calledFrom = localStorage.getItem("_calledFrom");
    // let emailAddress = '';
    // let phoneNumber = '';

    // if view contact detail is true then we need to show the phone number and email address
    // else the user can fill the detail
    if (this.petDetail.GDPRStatus) {
      if(this.petDetail.Company){
        if(this.petDetail.OwnerContactNumber || this.petDetail.OwnerEmail){
          this.IsCompany = true;
      this.phoneNumber = this.petDetail?.OwnerContactNumber;
      this.emailAddress = this.petDetail?.OwnerEmail
    }else{
      this.IsCompany = false;
      this.phoneNumber = this.petDetail?.userContactNumber;
      this.emailAddress = this.petDetail?.userEmailID
    }
    }else{
      this.IsCompany = false;
      this.phoneNumber = this.petDetail?.userContactNumber;
      this.emailAddress = this.petDetail?.userEmailID
    }
    }

    this.ReportForm = this.formbuilder.group({
      Name: ['', [Validators.required, this.noWhitespaceValidator]],
      EmailId: [this.emailAddress, [this.noWhitespaceValidator]],
      MobileNumber: [this.phoneNumber, [Validators.required, this.noWhitespaceValidator]],
      Description: [''],
      IsTermsAccepted: ['', [Validators.required, this.validateIfChecked]]
    });
  }

  onSubmit() {
    this.submitted = true;
    console.log(this.data)
    // console.log(this.PersonalForm.value);
    if (this.ReportForm.invalid) {
      return;
    }
    if (this.data.ChipId) {
      this.ReportForm.value.ChipId = this.data.ChipId;
    }
    this.ReportForm.value.LostFoundId = this.data.LostFoundID;
    this.petsService.addContactOwnerInformation(this.ReportForm.value).subscribe((res: any) => {
      if (res.error == "" || !res.error) {
        // alert("Takk, din kontaktinformasjon ble sendt til dyreeiers registrerte e-postadresse. Du kan nå kontaktes av dyreeier.");
        alert("Takk. Informasjon sendes til annonsørens registrerte e-post/mobil nr. Annonsøren kan da kontakte deg på e-post eller telefon.");
        this.CloseDialogPopup()
      }
      else {
        alert(res.error);
        this.CloseDialogPopup()
      }
    })

  }
  CloseDialogPopup(): void {
    this.dialogReportLost.close();
    this.dialogReportFound.close();
  }
  public noWhitespaceValidator(control: FormControl) {
    if (control.value && control.value.length > 0) {
      const isWhitespace = (control.value || '').trim().length === 0;
      const isValid = !isWhitespace;
      return isValid ? null : { 'whitespace': true };
    }
  }
  public validateIfChecked(control: FormControl) {
    if (control.value) {
      return null
    }
    else {
      return { 'checked': true };
    }

  }
  scrollTo(el: Element): void {
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }

  scrollToError(): void {
    const firstElementWithError = document.querySelector('.ng-invalid[formControlName]');
    this.scrollTo(firstElementWithError);
  }

  open(content) {
    this.modalService.open(content, { size: 'lg', ariaLabelledBy: 'modal-basic-title', backdrop: 'static', windowClass: 'my-modal-popup' }).result.then((result) => {

      //return false;
    }, (reason) => {

    });
    return false;
  }

  onfocus() {
    try {
      this.myScrollContainer.nativeElement.scroll({
        top: this.myScrollContainer.nativeElement.scrollHeight,
        left: 0,
        behavior: 'smooth'
      });
    }
    catch (err) {
    }
  }
  openPhoneDialer(PhoneNumber: any): void {
    document.location.href = "tel:"+PhoneNumber;
  }
}
